<template>
  <div class="left-sidebar">
          <!-- 侧边栏关闭 -->
      <div class="sidebar-close-area" v-show="isClosed">
          <div class="sidebar-open-btn" @click="openSidebar()"></div>
          <div class="youhui-icons">
              <router-link to="/discounts/all">
                <img src="./img/youhui_ico.png" alt />
              </router-link>
              <router-link to="/discounts/all">
                <img src="./img/promotion_icon.png" alt />
              </router-link>              
          </div>
          <div class="left-game-lists" v-for="(item,index) in sidebarGameList" :key="index">
              <a href="javascript:void(0)" @click="handleGoRouter(item)" >
                <img :src="item.logoImg" />
                <!-- <span class="logoImg" :style="{backgroundImage:'url(' + item.logoImg + ')'}"></span> -->
                <!-- <span>{{$t(item.name)}}</span> -->
              </a>            
          </div>
          <div class="youhui-icons">
              <router-link to="/mine/invitation">
                <img src="./img/vip_club.png" alt />
                <img class="bonus" v-if="!$store.state.inviteInfo.claimedBonus" src="../../assets/images/invitation/pic-bonus.png" alt="">
                <div class="receive" v-if="!!$store.state.inviteInfo.claimedBonus">
                  receive {{$store.state.inviteInfo.claimedBonus}}
                </div>
              </router-link>
              <router-link to="/agency">
                <img src="./img/affliliate_icon.png" alt />
              </router-link>              
          </div>          
      </div>
      <!--侧边栏展开-->
      <div class="sidebar-open-area" v-show="isOpen">
          <div class="sidebar-close-btn" @click="closeSidebar()"></div>
          <span class="sidebar-logo"></span>
          <div class="youhui-icons">
              <router-link to="/discounts/all">
                <span class="img-icon"><img src="./img/youhui_ico.png" alt /></span>
                <span>{{$t('newHome.bonuses')}}</span>
              </router-link>
              <router-link to="/discounts/all">
                <span class="img-icon"><img src="./img/promotion_icon.png" alt /></span>
                <span>{{$t('newHome.promotion')}}</span>

              </router-link>              
          </div>
          <div class="left-game-lists" v-for="(item,index) in sidebarGameList" :key="index">
              <a href="javascript:void(0)" @click="handleGoRouter(item)" >
                <span class="img-icon"><img :src="item.logoImg" /></span>
                <span>{{$t(item.title)}}</span>
              </a>            
          </div>
          <div class="youhui-icons">
              <router-link to="/mine/invitation">
                <span class="img-icon"><img src="./img/vip_club.png" alt /></span>
                <span>{{$t('newHome.invitation')}}</span>
                <img class="bonus" v-if="!$store.state.inviteInfo.claimedBonus" src="../../assets/images/invitation/pic-bonus.png" alt="">
                <div class="receive" v-if="!!$store.state.inviteInfo.claimedBonus">
                  receive {{$store.state.inviteInfo.claimedBonus}}
                </div>
              </router-link>
              <router-link to="/agency">
                <span class="img-icon"><img src="./img/affliliate_icon.png" alt /></span>
                <span>{{$t('newHome.affiliate')}}</span>
              </router-link>              
          </div>   

      </div>
    </div>


</template>

<script>
import { common, commonApi } from "@/common/index";
import { mapState, mapMutations, mapActions } from "vuex";
import { WEBSITE, HOTEL } from "../../assets/js/domian";
import 'vuetify/dist/vuetify.min.css'
export default {
  name: "sideBar",
  computed: {
    ...mapState({
      jin_sha_global_login_state: (state) => state.jin_sha_global_login_state, // 是否在首页
      UUID: (state) => state.UUID,
      appJump: (state) => state.linkList.appJump,
      isLogin: (state) => state.isLogin,
      accountBalance: (state) => state.userInfo.assetsInfoMap.accountBalance,
      userAccount: (state) => state.userInfo.userInfo.userAccount,
      inEmailNoRead: state => state.inEmailNoRead
    }),
  },

  data() {
    return {
      yhPcLiveChatList:'',
      yhPcWhatsappList:'',
      isOpen: false,
      isClosed: true,
      sidebarGameList:[
          { title:'newHome.Casino', url:'/games', logoImg: require("./img/casino_icon.png")},
          { title:'newHome.sport', url:'/sports', logoImg: require("./img/sport_icon.png")},
          { title:'newHome.lottery', url:'/games', logoImg: require("./img/lottery_icon.png")},
          { title:'newHome.Fishing', url:'/fish', logoImg: require("./img/fish_icon.png")},
          { title:'newHome.slot', url:'/slots', logoImg: require("./img/slot_icon.png")},
      ],
    };
  },
  methods: {
    ...mapMutations(["setshowloginfloat2","setTableVisible",]),
    ...mapActions(["checkLogin", "IS_LOGIN_FOCUS", "getFirstInfo"]),
    handleGoRouter(url){
      this.$router.push({ path:url.url})
    },
    openSidebar(){
      this.isOpen = true;
      this.isClosed = false;
    },
    closeSidebar(){
      this.isOpen = false;
      this.isClosed = true;
    },
  },
  mounted() {

},
  destroyed() {
  },
  created() {
  },
};
</script>

<style scoped lang="scss">
.left-sidebar{
  background: #fff;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;

  .sidebar-close-area{
    width: 132px;
      border-right: 1px solid #e7e7e7;

    .sidebar-open-btn{
      display: block;
      width: 84px;
      height: 68px;
      margin: 30px auto 0;
      background:url('./img/open_icon.png') no-repeat top center;
      cursor: pointer;
    }
    .youhui-icons{
      padding: 80px 0 40px;
      margin: 0 8px;
      border-bottom: 1px solid #848484;
      text-align: center;
      a{
        display: block;
        padding: 10px 0;
        margin-bottom: 20px;
        position: relative;
        .bonus{ position: absolute; right:10px; top:-15px; width:50px }
        .receive{
          min-width:75px;
          line-height:20px;
          position: absolute;
          top:-20px;
          left:50%;
          transform: translateX(-50%);
          font-size:12px;
          background-color:#e12d2d;
          border-radius: 100px;
          padding:2px 10px;
          text-align: center;
          color:#FFEE54;
          &::after{
            position: absolute;
            display: block;
            width: 0;
            height: 0;
            border-color: transparent;
            border-style: solid;
            content: " ";
            border-width: 6px;
            bottom: 1px px;
            margin-left: -6px;
            border-top-color: #e12d2d;
            border-bottom-width: 0;
          }
        }
      }
    }
    .left-game-lists{
      text-align: center;
      padding-top: 20px;
      a{
        display: block;
        padding: 10px 0 0; 
        margin-top: 15px;
      }      
    }
  }  

  .sidebar-open-area{
    width: 278px;
    height: 100vh;
    position: relative;
    border-right: 1px solid #e7e7e7;
    .sidebar-close-btn{
      display: block;
      width: 49px;
      height: 52px;
      margin: 30px 0 0 20px;
      background:url('./img/close_icon.png') no-repeat top center;
      cursor: pointer;
    }
    .sidebar-logo{
      position: absolute;
      top: 4px;
      left: 100px;
      width: 79px;
      height: 46px;
      background:url('./img/logo.png') no-repeat top center;
    }
    .img-icon{
      display: inline-block;
      width: 65px;
      vertical-align: middle;
      text-align: left;
      img{max-width: 100%;}
    }
    .youhui-icons{
      padding: 60px 0 40px 0;
      margin: 0 8px;
      a{
        display: block;
        padding: 10px 0 10px 35px;
        margin-bottom: 5px;
        color: #999;
        background: #eff0f3;
        font-size: 15px;
        position: relative;
        .bonus{ position: absolute; right:10px; top:-15px; width:50px }
        .receive{
          min-width:75px;
          line-height:20px;
          position: absolute;
          top:-20px;
          left:50%;
          transform: translateX(-50%);
          font-size:9px;
          background-color:#e12d2d;
          border-radius: 100px;
          padding:2px 10px;
          text-align: center;
          color:#FFEE54;
          &::after{
            position: absolute;
            display: block;
            width: 0;
            height: 0;
            border-color: transparent;
            border-style: solid;
            content: " ";
            border-width: 6px;
            bottom: 1px px;
            margin-left: -6px;
            border-top-color: #e12d2d;
            border-bottom-width: 0;
          }
        }
      }
      a:hover{background: #dfe0e3;} 
    }
    .left-game-lists{
      margin: 0 8px;
      a{
        display: block;
        padding: 10px 0 10px 35px;
        margin-bottom: 5px;
        color: #999;
        background: #eff0f3;
        font-size: 15px;
      }     
      a:hover{background: #dfe0e3;} 
    }
  }    
}

</style>



// WEBPACK FOOTER //
// src/pages/build901/components/sideBar/sideBar.vue